
import { PropTypes } from 'prop-types';
import { useEffect, useState } from 'react';
import Accordion from './campusLife/accordion';
const FaqContent = ({ title, accordionData }) => {


    const [accordion, setAccordion] = useState([])

    useEffect(() => {
        console.log(accordionData)
        setAccordion(accordionData)
    }, [accordionData])



    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <Accordion accordion={accordion} setAccordion={setAccordion} />

        </div>
    )
}
FaqContent.propTypes = {
    title: PropTypes.string,
    accordionData: PropTypes.any
}
export default FaqContent